module.exports = __webpack_public_path__ + "media/public/img/instagram-round-01-d873700d03cfe9216e9fb2676c2aa726.svg";